import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ShopifyStorefrontService } from '../../services/shopify-storefront.service';
import { ColorWithoutTitlePipe } from '../../pipes/color-without-title.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-swatches',
  imports: [CommonModule, ColorWithoutTitlePipe],
  templateUrl: './product-swatches.component.html',
  styleUrl: './product-swatches.component.scss'
})
export class ProductSwatchesComponent implements AfterViewInit {
  @Input('product') parentProduct: any = null;
  @Input('preload-size') size: number = 450;
  @Input('method') method: string = 'group-tag';
  @Output() selectedProduct = new EventEmitter<any>();

  @ViewChild('colorways', { static: true }) colorways!: ElementRef;
  observer!: IntersectionObserver;

  groupedProducts: any[] = [];
  constructor(
    private data: ShopifyStorefrontService
  ) { }
  get products() {
    return this.data.getCachedProductsByTag(this.groupTag);
  }

  get groupTag() {
    return this.parentProduct.tags.find((tag: string) => tag.includes('group-'));
  }

  turnIntoGradient(colors: any) {
    const gradientColors = typeof colors == 'string' ? JSON.parse(colors) : colors;
    if (gradientColors.length === 1) {
      return gradientColors[0];
    }
    return `linear-gradient(90deg, ${gradientColors.join(', ')})`;
  }

  preLoadImage(product: any) {
    const image = new Image();
    image.src = product.featuredImage.url + `&width=${this.size}`;
  }
  emitProduct(product: any) {
    this.selectedProduct.emit(product);
  }

  preloadImages() {
    this.products.forEach((product: any) => {
      this.preLoadImage(product);
    });
  }

  ngAfterViewInit() {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.preloadImages();
              this.observer.unobserve(entry.target);
            }
          });
        },
        { root: null, threshold: 1 }
      );
      if (this.colorways) {
        this.observer.observe(this.colorways.nativeElement);
      }
    }
  }
}
